import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import { CampaignPartnerStatus } from "../../enums/campaign.enums";
import { Partner } from "../../models/partner";
import { PartnerCampaign } from "../../models/partnerCampaign";
import { PartnerCampaignService } from "../../services/api/partner-campaign.service";
import { PartnerService } from "../../services/api/partner.service";
import { DialogService } from "../../services/dialog.service";
import { NotificationService } from "../../services/notification.service";
import { PartnerUrl } from "../../../partner/partner.url";

@Component({
  selector: "app-partner-campaign-leave-campaign-link",
  templateUrl: "./partner-campaign-leave-campaign-link.component.html",
  styleUrl: "./partner-campaign-leave-campaign-link.component.scss",
})
export class PartnerCampaignLeaveCampaignLinkComponent
  implements OnInit, OnChanges
{
  @Input()
  public campaign!: PartnerCampaign;
  @Input()
  public partner!: Partner;

  private canLeaveCampaign = false;
  constructor(
    private readonly router: Router,
    private readonly dialogService: DialogService,
    private readonly partnerService: PartnerService,
    private readonly partnerCampaignService: PartnerCampaignService,
    private readonly notificationService: NotificationService,
  ) {}

  public ngOnInit(): void {
    this.initData(this.campaign);
  }

  public ngOnChanges({ campaign }: SimpleChanges): void {
    if (campaign) {
      this.initData(this.campaign);
    }
  }

  private initData(campaign: PartnerCampaign) {
    const isCampaignCancelled =
      campaign.campaignPartnerStatus === CampaignPartnerStatus.Cancelled;
    this.canLeaveCampaign = !isCampaignCancelled && campaign.canPartnerLeave;
  }

  protected async checkLeaveLink(event: MouseEvent): Promise<void> {
    const target = event.target as HTMLElement;

    if (target.classList.contains("leave-link")) {
      await this.showLeaveCampaignConfirmation();
    }
  }

  private async showLeaveCampaignConfirmation(): Promise<void> {
    void this.dialogService.confirm({
      title: "partner.campaign.summary.leaveCampaign",
      message: this.canLeaveCampaign
        ? "partner.campaign.summary.leaveCampaignConfirmTitle"
        : "partner.campaign.summary.leaveCampaignWithPendingPosts",
      onConfirm: () => this.leaveCampaign(),
    });
  }

  private async leaveCampaign(): Promise<void> {
    this.partnerCampaignService
      .cancelCampaign(this.partnerService.currentPartnerId, this.campaign.id)
      .subscribe({
        next: async () => {
          await this.router.navigate([PartnerUrl.Home(this.partner.id)]);
        },
        error: () => {
          this.notificationService.error("shared.changesCouldNotBeSaved");
        },
      });
  }
}
